<!-- Оверлей теперь управляется отдельным компонентом app-ui-modal-overlay -->
@let scroll_style__local = scrollStyle();

<div
  class="modal_wrapper z-10 flex w-full flex-col gap-4 sm:gap-6"
  [class.modal_slide_down]="isClosing()"
  [class.p-4]="paddingStyle() === Padding.SHOW"
  [class.p-6]="paddingStyle() === Padding.SIX"
  [class.modal-background]="backgroundStyle() === EBackground.SHOW"
>
  <div
    class="modal_drag_handle xsm:hidden absolute -top-4 left-0 w-full"
    libSwipe
    [swipeThreshold]="30"
    [ignoreChildrenScroll]="true"
    (swipeDown)="handleSwipeDown()"
  >
    <span
      class="modal_drag_hitbox"
      aria-hidden="true"
      (click)="handleDragHitboxClick()"
    ></span>
    <div class="h-1 w-16 mx-auto bg-white rounded-sm"></div>
  </div>

  <!-- Single swipe host for title + scroll body (avoids stacking two libSwipe on wrapper + content) -->
  <div class="modal_swipe_zone flex min-h-0 w-full flex-1 flex-col gap-4 sm:gap-6">
    <div
      class="modal_header xsm:max-w-[26rem] flex w-full items-center justify-between gap-[1rem] sm:max-w-none"
      [class.hidden]="!label()"
      [class.shrink-0]="scroll_style__local === Scroll.HIDE"
    >
      @if (label(); as label) {
        <div class="modal_title text-grey-100 truncate text-2xl font-medium">
          {{ label | transloco }}
        </div>
      }
      @if (!hideCloseButton() && !modalEntry()?.options?.hideCloseButton) {
        <app-ui-button
          class="modal_close size_big style_ghost xsm:block hidden"
          (buttonClick)="requestClose()"
        >
          <i
            icon-left
            class="close_icon ph ph-x text-2xl/6"
          ></i>
        </app-ui-button>
      }
    </div>

    <div
      class="modal_body flex max-h-full min-h-0 w-full flex-1"
      [class.tma:pb-safe-0]="!disableTmaBodySafeArea()"
      [class.overflow-y-auto]="scroll_style__local === Scroll.SHOW"
      [class.no-scrollbar]="scroll_style__local === Scroll.SHOW"
      [class.modal_body_fill]="scroll_style__local === Scroll.HIDE"
    >
      <div
        class="modal-content"
        [class.modal-content_fill]="scroll_style__local === Scroll.HIDE"
      >
        @if (modalEntry()?.templateRef; as tpl) {
          <ng-container *ngTemplateOutlet="tpl" />
        } @else if (modalEntry()?.component) {
          <ng-container *ngComponentOutlet="modalEntry()!.component!; inputs: modalEntry()!.inputs" />
        } @else {
          <ng-content />
        }
      </div>
    </div>
  </div>
</div>
